/**
 * Common parameters for API list/search endpoints.
 * Mirrors the shape used by getList in apiUtils and API controllers.
 */
export interface ApiListParams {
  filters?: Record<string, string>;
  scopes?: Record<string, string>;
  sort?: string;
  order?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

/**
 * Same as ApiListParams but with _scopes, _sort, _order, _page, _limit for API
 * functions that use those parameter names (and pass them to getList in order).
 */
export interface ApiListParamsWithUnderscores {
  filters?: ApiListParams['filters'];
  _scopes?: ApiListParams['scopes'];
  _sort?: ApiListParams['sort'];
  _order?: ApiListParams['order'];
  _page?: ApiListParams['page'];
  _limit?: ApiListParams['limit'];
}

/**
 * Parameters for export endpoints (filters + scopes only).
 * Use for all export/exportData-style API functions.
 */
export interface ApiExportParams {
  filters: Record<string, string>;
  scopes: Record<string, string>;
}

/** Use these for the 6 list params (filters, _scopes, _sort, _order, _page, _limit) in API functions. */
export type ApiListParamFilters = ApiListParams['filters'];
export type ApiListParamScopes = ApiListParams['scopes'];
export type ApiListParamSort = ApiListParams['sort'];
export type ApiListParamOrder = ApiListParams['order'];
export type ApiListParamPage = ApiListParams['page'];
export type ApiListParamLimit = ApiListParams['limit'];

/** Convert underscore-style params to ApiListParams for getList. */
export function toListParams(p?: ApiListParamsWithUnderscores | null): ApiListParams | undefined {
  if (p == null) return undefined;
  return {
    filters: p.filters,
    scopes: p._scopes,
    sort: p._sort,
    order: p._order,
    page: p._page,
    limit: p._limit,
  };
}
